export var urlConstants = {
    SITE_LINKS_DESKTOP: 'v1.0/espot?emsName=BJsEmailFooterEspotSecond&pageName=HomePage&pageGroup=Content&catalogId=10201&storeId=10201&langId=-1',
    SITE_LINKS_MOBILE: 'v1.0/espot?emsName=BJsMobileFooterEspot&pageName=HomePage&pageGroup=Content&catalogId=10201&storeId=10201&langId=-1',
    FOOTER_SIGNIN: 'v1.0/stores/10201/email/preferences/marketing?optin=1',
    SOCIAL_LINKS_DESKTOP: 'v1.0/espot?emsName=BJsEmailFooterEspotFirst&pageName=HomePage&pageGroup=Content&catalogId=10201&storeId=10201&langId=-1'
};
